import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            视频分类
          </h2>
          <Link to="/category/all" className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap flex items-center gap-1">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-500/40 transition-all duration-200 hover:bg-background-200/50 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}